import LanguageIcon from './icons/languageIcon'
import SelectedIcon from '../icons/circleCheck'
import { MenuButton, MenuButtonControlProps } from './menuButton'
import { useTranslator } from '../translator/hook'
import { LanguageNames } from '../../../i18n/translation'
import './LanguageButton.css'

export const LanguageButton = (menuProps: MenuButtonControlProps) => {
  const { language, t, setLanguage } = useTranslator()

  return (
    <MenuButton
      menuIcon={<LanguageIcon className="icon" />}
      menuName={t('button_language')}
      {...menuProps}
    >
      {Object.entries(LanguageNames).map(([key, value]) => (
        <li
          key={key}
          className="language-menu-item"
          onClick={() => setLanguage(key)}
        >
          <span>{value}</span>
          {key === language && <SelectedIcon />}
        </li>
      ))}
    </MenuButton>
  )
}
